"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isReading = void 0;
const isReading = (obj) => {
    return typeof obj === 'object' && obj !== null && typeof obj.id === 'string' && typeof obj.timestamp === 'number';
};
exports.isReading = isReading;
